import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-5" }, null, -1)
const _hoisted_2 = { class: "card shadow-sm" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header\"><h3 class=\"card-title text-gray-800\"><i class=\"bi bi-nut fs-2 text-primary\"></i>   Podium Hacking Club </h3></div><div class=\"card-body\"><p class=\"fs-4 text-gray-700 mb-7\"> O Podium Hacking Club é um lugar onde você pode identificar os melhores e mais talentosos membros do Hacking Club! </p></div>", 2)
const _hoisted_5 = { class: "d-flex flex-column gap-2" }
const _hoisted_6 = { class: "d-flex flex-stack justify-between" }
const _hoisted_7 = { class: "symbol symbol-50px d-flex flex-col gap-3" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "fs-6 fw-bold text-gray-800 mt-2" }
const _hoisted_10 = { class: "text-muted fw-semibold d-block fs-7" }
const _hoisted_11 = { class: "d-flex gap-4 flex-stack" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "mt-2 cursor-pointer" }
const _hoisted_15 = {
  key: 1,
  class: "symbol symbol-40px d-grid text-center items-center justify-center align-center align-content-center"
}
const _hoisted_16 = { style: {"width":"40px","background-color":"black","height":"40px","border-radius":"10px","display":"flex","justify-content":"center","align-items":"center","align-content":"center"} }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-1 mt-10" }, null, -1)

import {computed, ref, onMounted} from "vue";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import ApiService from "@/core/services/ApiService";
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const router = useRouter();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const certificationOK = ref<boolean>();
const terms = ref(false);
const isChecked = ref(false);
const loading = ref(false);
const allUsers = ref([]);

ApiService.get("/account/podium").then((response) => {
  
  if(response.status === 200){
    allUsers.value = response.data;
  }
});

const allPatents = ref([]);

const generateAllPatentsData = (language: string) => {
  return [
    {
      id: 0,
      name: t(`${language}.patents.recruit`),
      icon: 'recruta.png',
      point_range: [0, 1999]
    },
    {
      id: 1,
      name: t(`${language}.patents.soldier`),
      icon: 'soldado.png',
      point_range: [2000, 3999]
    },
    {
      id: 2,
      name: t(`${language}.patents.cable`),
      icon: 'cabo.png',
      point_range: [4000, 5999]
    },
    {
      id: 3,
      name: t(`${language}.patents.3rd_sergeant`),
      icon: '3-sargento.png',
      point_range: [6000, 7999]
    },
    {
      id: 4,
      name: t(`${language}.patents.2rd_sergeant`),
      icon: '2-sargento.png',
      point_range: [8000, 9999]
    },
    {
      id: 5,
      name: t(`${language}.patents.1rd_sergeant`),
      icon: '1-sargento.png',
      point_range: [10000, 11999]
    },
    {
      id: 6,
      name: t(`${language}.patents.warrant_officer`),
      icon: 'subtenente.png',
      point_range: [12000, 13999]
    },
    {
      id: 7,
      name: t(`${language}.patents.aspirant`),
      icon: 'aspirante.png',
      point_range: [14000, 15999]
    },
    {
      id: 8,
      name: t(`${language}.patents.2nd_lieutenant`),
      icon: '2-tenente.png',
      point_range: [16000, 17999]
    },
    {
      id: 9,
      name: t(`${language}.patents.1nd_lieutenant`),
      icon: '1-tenente.png',
      point_range: [18000, 19999]
    },
    {
      id: 10,
      name: t(`${language}.patents.captain`),
      icon: 'capitao.png',
      point_range: [20000, 21999]
    },
    {
      id: 11,
      name: t(`${language}.patents.major`),
      icon: 'major.png',
      point_range: [22000, 23999]
    },
    {
      id: 12,
      name: t(`${language}.patents.lieutenant_colonel`),
      icon: 'tenente-coronel.png',
      point_range: [24000, 25999]
    },
    {
      id: 13,
      name: t(`${language}.patents.colonel`),
      icon: 'coronel.png',
      point_range: [26000, 27999]
    },
    {
      id: 14,
      name: t(`${language}.patents.attack_general`),
      icon: 'general-de-ataque.png',
      point_range: [28000, 29999]
    },
    {
      id: 15,
      name: t(`${language}.patents.stealth_general`),
      icon: 'general-de-furtividade.png',
      point_range: [30000, 31999]
    },
    {
      id: 16,
      name: t(`${language}.patents.general_of_intelligence`),
      icon: 'general-de-inteligencia.png',
      point_range: [32000, 33999]
    },
    {
      id: 17,
      name: t(`${language}.patents.marshal`),
      icon: 'marechal.png',
      point_range: [34000, 39999]
    },
    {
      id: 18,
      name: t(`${language}.patents.supreme_commander`),
      icon: 'supremo-comandante.png',
      point_range: [40000, 49999]
    },
    {
      id: 19,
      name: t(`${language}.patents.grand_marshal`),
      icon: 'grao-marechal.png',
      point_range: [50000, 59999]
    },
    {
      id: 20,
      name: t(`${language}.patents.warlord`),
      icon: 'senhor-da-guerra.png',
      point_range: [60000, 69999]
    },
    {
      id: 21,
      name: t(`${language}.patents.arconte`),
      icon: 'arconte.png',
      point_range: [70000, 79999]
    },
    {
      id: 22,
      name: t(`${language}.patents.supreme_leader`),
      icon: 'lider-supremo.png',
      point_range: [80000, 89999]
    },
    {
      id: 23,
      name: t(`${language}.patents.primordial`),
      icon: 'primordial.png',
      point_range: [90000, 99999]
    },
    {
      id: 24,
      name: t(`${language}.patents.hakai`),
      icon: 'hakai.png',
      point_range: [100000, Infinity]
    }
  ].reverse();
};

const updateAllPatents = (language: string) => {
  //@ts-ignore
  allPatents.value = generateAllPatentsData(language);
};
updateAllPatents(currentLanguage.value);

const gotoUserProfile = (userId: number) => {
  router.push({name: 'profile-user', params: {id: userId}});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allPatents.value, (patent) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "px-1 py-1 mx-5 mb-1",
              key: patent.name
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    src: '/media/logos/badges/'+patent?.icon,
                    class: "h-50 align-self-center",
                    alt: ""
                  }, null, 8, _hoisted_8),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(patent?.name), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.profile_public.point_range`)) + ": " + _toDisplayString(patent.point_range[0]) + " - " + _toDisplayString(patent.point_range[1]), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (allUsers.value[patent?.id])
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(allUsers.value[patent?.id]['users'], (user) => {
                        return (_openBlock(), _createElementBlock("div", {
                          onClick: ($event: any) => (gotoUserProfile(user?.user_id)),
                          class: "symbol symbol-40px d-grid text-center items-center justify-center align-center align-content-center",
                          style: {"justify-items":"center"}
                        }, [
                          _createElementVNode("img", {
                            src: user?.user?.profile_photo_path ? user?.user?.profile_photo_path :  '/media/logos/badges/'+patent?.icon,
                            class: "h-45 w-45 cursor-pointer",
                            alt: ""
                          }, null, 8, _hoisted_13),
                          _createElementVNode("b", _hoisted_14, _toDisplayString(user?.user?.nick || 'No nick'), 1)
                        ], 8, _hoisted_12))
                      }), 256))
                    : _createCommentVNode("", true),
                  (allUsers.value[patent?.id] && allUsers.value[patent?.id]['total_users'] > allUsers.value[patent?.id]['users'].length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, " +" + _toDisplayString(allUsers.value[patent?.id]['total_users'] - allUsers.value[patent?.id]['users'].length), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_17
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})